import { helper } from '@ember/component/helper';
const formatter = new Intl.NumberFormat('de-DE', {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
});
const quotient = 1000;

export function displaySize(positional /*, named*/) {
  if (positional?.length !== 1) {
    return positional;
  }
  const size = positional[0] as number;
  const l = (size ?? 0) / (quotient ?? 1);
  // const ml = Math.floor((size - l * 1000) / 10);
  return `${formatter.format(l)} l`;
}
export function reverseDisplaySize(value /*, named*/) {
  const sizeNum = parseFloat(value.replace(',', '.'));
  if (isNaN(sizeNum)) {
    return null;
  }
  return Math.round(sizeNum * quotient);
}

export default helper(displaySize);
